namespace Core {
    angular
        .module('core')
        .directive('invalidHolidayStartDateModal', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {
                    show: '=',
                    close: '&'
                },
                templateUrl: 'partials/Home/directivetemplate?type=InvalidHolidayStartDateModal'
            };
        });
}
